/**
 * Shared style fragments so glass surfaces never need to reinvent
 * field/table recipes. Typography inside glass is dark ink over a
 * white translucent scrim, so text must always sit inside a surface.
 */

export const glassFieldSx = {
  "input, select, textarea": {
    background: "rgba(255, 255, 255, 0.78)",
    borderColor: "rgba(15, 23, 42, 0.14)",
    color: "#2d3748",
  },
  "input::placeholder, textarea::placeholder": {
    color: "rgba(45, 55, 72, 0.55)",
  },
  "input:focus, select:focus, textarea:focus": {
    background: "rgba(255, 255, 255, 0.94)",
    borderColor: "#9bc04d",
    boxShadow: "0 0 0 1px #9bc04d",
  },
  "input:disabled, select:disabled, textarea:disabled": {
    color: "rgba(45, 55, 72, 0.55)",
  },
  option: {
    background: "#ffffff",
    color: "#2d3748",
  },
};

export const glassTableSx = {
  th: {
    color: "rgba(45, 55, 72, 0.72)",
    borderColor: "rgba(15, 23, 42, 0.12)",
    letterSpacing: "0.04em",
  },
  td: {
    color: "#2d3748",
    borderColor: "rgba(15, 23, 42, 0.08)",
  },
  "tbody tr:hover": {
    background: "rgba(255, 255, 255, 0.55)",
  },
};

export const glassDividerSx = {
  hr: { borderColor: "rgba(15, 23, 42, 0.12)" },
};

export const glassContentSx = {
  ...glassFieldSx,
  ...glassTableSx,
  ...glassDividerSx,
};
